import { getEnergyTypeColor } from './energyIcons';

export type CollectionPointType = 'electricity' | 'gas' | 'water' | 'coal' | 'heat' | 'other';

export const COLLECTION_POINT_NAME_LABEL = 'Název odběrného místa';

export const customCollectionPointUnitOptions = [
    { value: 'kWh', label: 'Kilowatthodina (kWh)' },
    { value: 'MWh', label: 'Megawatthodina (MWh)' },
    { value: 'GJ', label: 'Gigajoule (GJ)' },
    { value: 'm3', label: 'Metr krychlový (m³)' },
    { value: 'l', label: 'Litr (l)' },
    { value: 'kg', label: 'Kilogram (kg)' },
    { value: 't', label: 'Tuna (t)' },
    { value: 'ks', label: 'Kus (ks)' },
] as const;

const normalizeCustomType = (value?: string | null) => value
    ?.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim() ?? '';

export const getCollectionPointColor = (type: CollectionPointType, customType?: string | null): string => {
    void customType;
    return getEnergyTypeColor(type);
};

export const getCollectionPointTypeLabel = (type: CollectionPointType, customType?: string | null): string => {
    if (type === 'other' && customType) {
        const trimmedCustomType = customType.trim();
        const customTypeLabel = normalizeCustomType(trimmedCustomType) === 'drevo' ? 'Dřevo' : trimmedCustomType;
        return 'Jiné - ' + customTypeLabel;
    }
    switch (type) {
        case 'electricity':
            return 'Elektřina';
        case 'gas':
            return 'Plyn';
        case 'water':
            return 'Voda';
        case 'coal':
            return 'Uhlí';
        case 'heat':
            return 'Teplo';
        case 'other':
            return 'Jiné';
        default:
            return type;
    }
};

export const getCollectionPointUnit = (
    type: CollectionPointType | string,
    customType?: string | null,
    customUnit?: string | null
): string => {
    switch (type) {
        case 'electricity':
            return 'kWh';
        case 'gas':
            return 'm³';
        case 'water':
            return 'm³';
        case 'coal':
            return 'kg';
        case 'heat':
            return 'GJ';
        case 'other': {
            if (customUnit?.trim()) {
                const normalizedCustomUnit = customUnit.trim();
                return normalizedCustomUnit === 'm3' ? 'm³' : normalizedCustomUnit;
            }

            const normalizedCustomType = normalizeCustomType(customType);

            if (
                normalizedCustomType.includes('pelet')
                || normalizedCustomType.includes('pelety')
                || normalizedCustomType.includes('biomasa')
                || normalizedCustomType.includes('drevo')
            ) {
                return 'kg';
            }

            if (
                normalizedCustomType.includes('benzin')
                || normalizedCustomType.includes('nafta')
                || normalizedCustomType.includes('diesel')
                || normalizedCustomType.includes('petrol')
            ) {
                return 'l';
            }

            return '';
        }
        default:
            return '';
    }
};

export const getCollectionPointConsumptionLabel = (type: CollectionPointType | string, customType?: string | null): string => {
    switch (type) {
        case 'gas':
            return 'Spotřeba plynu';
        case 'water':
            return 'Spotřeba vody';
        case 'coal':
            return 'Spotřeba uhlí';
        case 'heat':
            return 'Spotřeba tepla';
        case 'other':
            return customType?.trim() ? `Spotřeba ${customType.trim()}` : 'Spotřeba';
        default:
            return 'Spotřeba';
    }
};
